import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPadlockLockedOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.25,
		d: "M5 7V4a3 3 0 1 1 6 0v3M3.75 7h8.5A1.25 1.25 0 0 1 13.5 8.25v5A1.25 1.25 0 0 1 12.25 14.5h-8.5A1.25 1.25 0 0 1 2.5 13.25v-5A1.25 1.25 0 0 1 3.75 7ZM8 10.25v1.75"
	})
});
export default SvgPadlockLockedOutlined;
